import { Injectable } from '@angular/core';
import {
    IndustriepartnerDefaultDTO,
    KundenlisteParseMismatchEntry,
    FehlerKorrekturDTO,
    UserRoles,
} from 'src/app/shared/model';
import { Observable } from 'rxjs';

@Injectable()
export abstract class IndustriepartnerService {
    abstract getIndustriepartnerDefaults(): Observable<
        IndustriepartnerDefaultDTO
    >;
    abstract setIndustriepartnerDefaults(
        mindestBestellMenge: number,
        mindestUmsatz: number,
        skonto: number,
        zusatzrabatt: number,
        lieferzeit: number,
        mengeObergrenze: number,
        lieferwegUeberweiser: boolean,
        lieferwegDirekt: boolean,
        bestell_email_empfaenger: string,
        bestell_email_zeit: string,
        mindestbestellmenge_versandeinheiten: boolean,
        mengenrabatte: any[],
        triggerbilder: any[],
    ): Observable<IndustriepartnerDefaultDTO>;
    abstract kundenListeEinlesen(
        file: File
    ): Observable<KundenlisteParseMismatchEntry[]>;
    abstract fehlerAbrufen(): Observable<KundenlisteParseMismatchEntry[]>;
    abstract fehlerKorrigieren(
        korrekturen: FehlerKorrekturDTO[]
    ): Observable<void>;
    abstract setFehlerListe(fehlerListe: KundenlisteParseMismatchEntry[]): void;
    abstract getFehlerListe(): Observable<KundenlisteParseMismatchEntry[]>;
    abstract setAnbieterNr(anbieterNr: number);
    abstract getAnbieterNr(): number;
    abstract updateApothekenIndustriepartnerStatus(data);
    abstract uploadCustomerRow(industriepartner, row);
    abstract loadBestandsApiToken(industriepartner);
    abstract changeApiState(industriepartner);
}
